export enum ControllerName {
  LoyaltyEffortDashboard = 'LoyaltyEffortDashboard',
  ClientIssueExperienced = 'ClientIssueExperienced',
  ManagementScorecard = 'ManagementScorecard',
  ScoreCard = 'ScoreCard',
  OverallRep = 'OverallRep',
  OverallRepTable = 'OverallRepTable',
  CorporatePulse = 'CorporatePulse',
  UnstructuredData = 'UnstructuredData',
  FrontlineDashboard = 'FrontlineDashboard',
  SOSWorkflow = 'SOSWorkflow',
  ClosedLoopTool = 'ClosedLoopTool',
  ClosedLoopRecord = 'ClosedLoopRecord',
  IndividualCoaching = 'IndividualCoaching',
  OuterLoopCreateRecord = 'OuterLoopCreateRecord',
  CoachingHistory = 'CoachingHistory',
  TierPerformance = 'TierPerformance',
  IndividualSurveyTable = 'IndividualSurveyTable',
  TextMiningEmergingTrends = 'TextMiningEmergingTrends',
  TextMiningFrequency = 'TextMiningFrequency',
  TextMiningWordCloud = 'TextMiningWordCloud',
  KeywordSummary = 'KeywordSummary',
  QuestionLevelAggregate = 'QuestionLevelAggregate',
  QuestionLevelAggregateChart = 'QuestionLevelAggregateChart',
  OuterLoopSnapshot = 'OuterLoopSnapshot',
  CoachingTool = 'CoachingTool',
  CoachingCards = 'CoachingCards',
  AdHocExports = 'AdHocExports',
  ExploreWithELLIE = 'ExploreWithELLIE',
  ReportUsage = 'ReportUsage',
  ProjectCustomerSearch = 'ProjectCustomerSearch',
  DIYDashboard = 'DIYDashboard',
  IndividualSurvey = 'IndividualSurvey',
  TierPerformanceChart = 'TierPerformanceChart',
  QuestionLevelAggregateOther = 'QuestionLevelAggregateOther',
  UDTopFocusAreas = 'UDTopFocusAreas',
  TextMiningBubbleChart = 'TextMiningBubbleChart',
  PDFViewer = 'PDFViewer',
}

export type DashboardType = {
  HasWeighting: boolean;
  TimePeriodType: string;
  IsYtd: boolean;
  IsV2: boolean;
  Title: string;
  DataGridID: string;
  wsGuid: string;
  idSurvey: string;
  DataGridId: string;
  dashboardId: string;
  ownerId: string;
  KeywordSummaryIds: Record<string, string>;
  Dashboard: {
    DashboardPermissions: Partial<{
      HasWriteAccess: boolean;
      CanShare: boolean;
      CanTransfer: boolean;
    }>;
  };
  DefaultDateQuickButton: string;
};
